// extracted by mini-css-extract-plugin
export var falconContainer = "_vg-2";
export var offerCenter = "_vg-0";
export var roktContainer = "_vg-1";